const EDITOR_BLOCK_STRUCTURE_RE = /<(ul|ol|li|img|table|blockquote|pre|hr|video|iframe)\b/i;

/** True when a contentEditable HTML string has no visible text (ignores empty tags). */
export function isHtmlEditorEmpty(html: string): boolean {
  const raw = String(html || '').trim();
  if (!raw) return true;
  if (typeof document === 'undefined') {
    return !raw.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, ' ').trim();
  }
  const el = document.createElement('div');
  el.innerHTML = raw;
  return !normalizeMailBody(el.innerText || '');
}

/**
 * True when the overlay placeholder should show.
 * Empty lists still occupy the editor, so they hide the placeholder even without text.
 */
export function isHtmlEditorVisuallyEmpty(html: string): boolean {
  if (!isHtmlEditorEmpty(html)) return false;
  return !EDITOR_BLOCK_STRUCTURE_RE.test(String(html || ''));
}

/** Normalisiert Plaintext für E-Mail-Versand (Zeilenumbrüche, NBSP, mehrfache Leerzeilen). */
export function normalizeMailBody(text: string): string {
  if (!text) return '';
  const cleaned = text
    .replace(/\r\n/g, '\n')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00a0/g, ' ')
    .split('\n')
    .map((line) => line.replace(/[ \t]+/g, ' ').trimEnd())
    .join('\n');
  return cleaned.replace(/\n{3,}/g, '\n\n').trim();
}
